import { render, staticRenderFns } from "./SelectedCourses.vue?vue&type=template&id=7052ac6e&scoped=true"
import script from "./SelectedCourses.vue?vue&type=script&lang=js"
export * from "./SelectedCourses.vue?vue&type=script&lang=js"
import style0 from "./SelectedCourses.vue?vue&type=style&index=0&id=7052ac6e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7052ac6e",
  null
  
)

export default component.exports